import moment from 'moment';
import { FC, useState } from 'react';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import { ButtonArea } from '../../../../../shared/button-area/button-area';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../../shared/dialog/dialog.styles';
import { CreateProviderSetupTabLink } from '../../../../shared/utils/iv-deep-link';
import { withPatientIvStatusDialogProvider } from '../../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../../shared/appointment-ended-message/appointment-ended-message';
import { InsuranceInfo } from '../../shared/insurance-info/insurance-info';
import { ManuallyVerifiedButton } from '../../shared/manually-verified-button';
import { RunVerificationButton } from '../../shared/run-verification-button';
import { SelfPayButton } from '../../shared/self-pay-button';
import { BoldText } from '../../styles';

const NpiInvalidStatusDialog: FC = (props) => {
  const { publish } = useEventBus();
  const { opened, onClose, isLoading, locationId, patientInfo, getProvider, selectedIvSummary, appointment } =
    usePatientIvStatusDialog();
  const [provider] = useState(getProvider(selectedIvSummary?.idProvider));

  const onUpdateProviderNpiClick = async () => {
    publish({
      messageType: 'navigate',
      data: {
        ...CreateProviderSetupTabLink(locationId, 1),
        crossFrame: true
      }
    });
    onClose();
  };

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateReceived && (
            <>&nbsp;- Run {moment.utc(selectedIvSummary.dateReceived).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        The National Provider Identifier (NPI) associated with {provider ? provider.name : 'Current Provider'} returned
        as "invalid".
        <br />
        <br />
        To continue, please verify and correct the NPI to rerun the verification process. Alternatively, you may
        manually verify the patient or designate them as self-pay.
      </DialogSubTitle>
      <br />
      <ButtonArea title="Fix Now" buttons={[{ title: 'Update Provider NPI', onClick: onUpdateProviderNpiClick }]} />
      <AppointmentEndedMessage />
      {patientInfo && <InsuranceInfo patientInfo={patientInfo} />}
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <RunVerificationButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(NpiInvalidStatusDialog);
